<!-- Header -->
<div class="modal-header">
  <h3 class="modal-title"><strong>Edit Attributes</strong></h3>
  <div class="header-actions">
    <i class="fa"
       [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}"
       style="margin-right: 10px; cursor: pointer;"
       (click)="minimise = !minimise"></i>
    <i class="fa fa-times" style="cursor: pointer;" (click)="cancel()"></i>
  </div>
</div>

<!-- Body -->
<form class="form-horizontal" novalidate [hidden]="minimise">
<div class="modal-body">
  <div class="divShadow1">

    <!-- Loading Spinner -->
    @if (loadingData) {
<div class="text-center" style="padding: 20px;">
      <i class="fa fa-spinner fa-pulse fa-2x"></i>
    </div>
}

    @if (!loadingData) {
<div style="margin-left: 30px; margin-right: 30px; margin-bottom: 30px">

      <!-- Row 1: Trans Category -->
      <div class="row">
        <div class="col-md-2">
          <label>Trans Category</label>
          <ap-dropdown class="ftc-form-dropdown field-full-width" [list]="transCategoryDataView"
  [selectType]="'single'" [title]="'Trans Category'" [hideTitleOnInput]="true" [inputAriaLabel]="'Trans Category'"
  [disabled]="QARScenario === 'Y'"
  [(ngModel)]="selectedTransCatItem"
  [ngModelOptions]="{standalone: true}"
  (onSelect)="onUpdateCountryFieldFromDropdown($event)">
  @for (item of transCategoryDataView; track item.value) {
    <ap-dropdown-list-item #dropdownListItem [item]="item"
      [ariaLabel]="setFormDropdownAriaLabel(item, 'Trans Category')"
      (onSelectItem)="onDropdownSelectItem($event)"></ap-dropdown-list-item>
  }
</ap-dropdown>
        </div>

        @if (newArray.indexOf('Basket') > -1) {
<div class="col-md-2">
          <label>Basket</label>
          <ap-dropdown class="ftc-form-dropdown field-full-width" [list]="basketCodeDataView"
  [selectType]="'single'" [title]="'Basket'" [hideTitleOnInput]="true" [inputAriaLabel]="'Basket'"
  [(ngModel)]="selectedBasketCodeItem"
  [ngModelOptions]="{standalone: true}"
  (onSelect)="onChangeBasketCodeFromDropdown($event)">
  @for (item of basketCodeDataView; track item.value) {
    <ap-dropdown-list-item #dropdownListItem [item]="item"
      [ariaLabel]="setFormDropdownAriaLabel(item, 'Basket')"
      (onSelectItem)="onDropdownSelectItem($event)"></ap-dropdown-list-item>
  }
</ap-dropdown>
        </div>
}

        @if (newArray.indexOf('SIC Code') > -1) {
<div class="col-md-2">
          <label>SIC Code</label>
          <ap-dropdown class="ftc-form-dropdown field-full-width" [list]="sicCodeDataView"
  [selectType]="'single'" [title]="'SIC Code'" [hideTitleOnInput]="true" [inputAriaLabel]="'SIC Code'"
  [showSearchbox]="true"
  [(ngModel)]="selectedSicCodeItem"
  [ngModelOptions]="{standalone: true}"
  (onSelect)="onSelectedSicCodeSelect($event)">
  @for (item of sicCodeDataView; track item.value) {
    <ap-dropdown-list-item #dropdownListItem [item]="item"
      [ariaLabel]="setFormDropdownAriaLabel(item, 'SIC Code')"
      (onSelectItem)="onDropdownSelectItem($event)"></ap-dropdown-list-item>
  }
</ap-dropdown>
        </div>
}

        @if (newArray.indexOf('FDII') > -1) {
<div class="col-md-2">
          <label>FDII</label>
          <ap-dropdown class="ftc-form-dropdown field-full-width" [list]="fdiiCodeDataView"
  [selectType]="'single'" [title]="'FDII'" [hideTitleOnInput]="true" [inputAriaLabel]="'FDII'"
  [(ngModel)]="selectedFdiiCodeItem"
  [ngModelOptions]="{standalone: true}"
  (onSelect)="onSelectedFdiiCodeSelect($event)">
  @for (item of fdiiCodeDataView; track item.value) {
    <ap-dropdown-list-item #dropdownListItem [item]="item"
      [ariaLabel]="setFormDropdownAriaLabel(item, 'FDII')"
      (onSelectItem)="onDropdownSelectItem($event)"></ap-dropdown-list-item>
  }
</ap-dropdown>
        </div>
}

        @if (newArray.indexOf('Applicable Year') > -1) {
<div class="col-md-2">
          <label>Withholding Applicable Year</label>
          <ap-dropdown class="ftc-form-dropdown field-full-width" [list]="filteredTaxYearDataView"
  [selectType]="'single'" [title]="'Withholding Applicable Year'" [hideTitleOnInput]="true" [inputAriaLabel]="'Withholding Applicable Year'"
  [(ngModel)]="applicableYearKeyItem"
  [ngModelOptions]="{standalone: true}"
  (onSelect)="onApplicableYearKeySelect($event)">
  @for (item of filteredTaxYearDataView; track item.value) {
    <ap-dropdown-list-item #dropdownListItem [item]="item"
      [ariaLabel]="setFormDropdownAriaLabel(item, 'Withholding Applicable Year')"
      (onSelectItem)="onDropdownSelectItem($event)"></ap-dropdown-list-item>
  }
</ap-dropdown>
        </div>
}

        @if (newArray.indexOf('Line No') > -1) {
<div class="col-md-2">
          <label>Line No</label>
          <ap-dropdown class="ftc-form-dropdown field-full-width" [list]="lineNoCodeDataView"
  [selectType]="'single'" [title]="'Line No'" [hideTitleOnInput]="true" [inputAriaLabel]="'Line No'"
  [disabled]="true"
  [(ngModel)]="selectedLineNoItem"
  [ngModelOptions]="{standalone: true}"
  (onSelect)="onSelectedLineNoSelect($event)">
  @for (item of lineNoCodeDataView; track item.value) {
    <ap-dropdown-list-item #dropdownListItem [item]="item"
      [ariaLabel]="setFormDropdownAriaLabel(item, 'Line No')"
      (onSelectItem)="onDropdownSelectItem($event)"></ap-dropdown-list-item>
  }
</ap-dropdown>
        </div>
}
      </div>

      <!-- Row 2: Beat / Beat Type / Beat Withhold / Related/Unrelated / Trading Partner / Country -->
      <div class="row">
        @if (newArray.indexOf('Beat') > -1) {
<div class="col-md-2">
          <label>BEAT</label>
          <ap-dropdown class="ftc-form-dropdown field-full-width" [list]="yesNoDataView"
  [selectType]="'single'" [title]="'BEAT'" [hideTitleOnInput]="true" [inputAriaLabel]="'BEAT'"
  [(ngModel)]="selectedBeatCodeItem"
  [ngModelOptions]="{standalone: true}"
  (onSelect)="onChangeBeatCodeFromDropdown($event)">
  @for (item of yesNoDataView; track item.value) {
    <ap-dropdown-list-item #dropdownListItem [item]="item"
      [ariaLabel]="setFormDropdownAriaLabel(item, 'BEAT')"
      (onSelectItem)="onDropdownSelectItem($event)"></ap-dropdown-list-item>
  }
</ap-dropdown>
        </div>
}

        @if (newArray.indexOf('Beat Type') > -1) {
<div class="col-md-2">
          <label>BEAT Type</label>
          <ap-dropdown class="ftc-form-dropdown field-full-width" [list]="beatTypeDataView"
  [selectType]="'single'" [title]="'BEAT Type'" [hideTitleOnInput]="true" [inputAriaLabel]="'BEAT Type'"
  [disabled]="selectedBeatCodeDesc === 'No'"
  [(ngModel)]="selectedBeatTypeCodeItem"
  [ngModelOptions]="{standalone: true}"
  (onSelect)="onSelectedBeatTypeCodeSelect($event)">
  @for (item of beatTypeDataView; track item.value) {
    <ap-dropdown-list-item #dropdownListItem [item]="item"
      [ariaLabel]="setFormDropdownAriaLabel(item, 'BEAT Type')"
      (onSelectItem)="onDropdownSelectItem($event)"></ap-dropdown-list-item>
  }
</ap-dropdown>
        </div>
}

        @if (newArray.indexOf('Beat Withhold') > -1) {
<div class="col-md-2">
          <label>Subject to BEAT Withhold (%)</label>
          <input type="text" class="form-control" style="width: 75px"
                 [(ngModel)]="selectedBeatWithhold"
                 [ngModelOptions]="{standalone: true}"
                 (ngModelChange)="changeSelectedBeatWithHold()"
                 [disabled]="selectedBeatCodeDesc === 'No'">
        </div>
}

        @if (newArray.indexOf('Related/Unrelated') > -1) {
<div class="col-md-2">
          <label>Related/Unrelated</label>
          <ap-dropdown class="ftc-form-dropdown field-full-width" [list]="relatedCodeDataView"
  [selectType]="'single'" [title]="'Related/Unrelated'" [hideTitleOnInput]="true" [inputAriaLabel]="'Related/Unrelated'"
  [disabled]="selectedBeatCodeDesc === 'Yes'"
  [(ngModel)]="selectedRelatedCodeItem"
  [ngModelOptions]="{standalone: true}"
  (onSelect)="onChangeRelatedCodeFromDropdown($event)">
  @for (item of relatedCodeDataView; track item.value) {
    <ap-dropdown-list-item #dropdownListItem [item]="item"
      [ariaLabel]="setFormDropdownAriaLabel(item, 'Related/Unrelated')"
      (onSelectItem)="onDropdownSelectItem($event)"></ap-dropdown-list-item>
  }
</ap-dropdown>
        </div>
}

        @if (newArray.indexOf('Trading Partner') > -1) {
<div class="col-md-2">
          <label>Trading Partner</label>
          <ap-dropdown class="ftc-form-dropdown field-full-width" [list]="tradingPartnerOptionsView"
  [selectType]="'single'" [title]="'Trading Partner'" [hideTitleOnInput]="true" [inputAriaLabel]="'Trading Partner'"
  [showSearchbox]="true"
  [disabled]="selectedRelatedCodeDesc !== 'Related Domestic' && selectedRelatedCodeDesc !== 'Related Foreign'"
  [(ngModel)]="selectedTradingPartnerCodeItem"
  [ngModelOptions]="{standalone: true}"
  (onSelect)="onChangeTradingPartnerFromDropdown($event)">
  @for (item of tradingPartnerOptionsView; track item.value) {
    <ap-dropdown-list-item #dropdownListItem [item]="item"
      [ariaLabel]="setFormDropdownAriaLabel(item, 'Trading Partner')"
      (onSelectItem)="onDropdownSelectItem($event)"></ap-dropdown-list-item>
  }
</ap-dropdown>
        </div>
}

        @if (newArray.indexOf('Country') > -1) {
<div class="col-md-2">
          <label>{{disableCountry === 'Yes' ? 'Trading Partner Country' : 'Country'}}</label>
          <ap-dropdown class="ftc-form-dropdown field-full-width" [list]="countryCodeDataView"
  [selectType]="'single'" [title]="'Country'" [hideTitleOnInput]="true" [inputAriaLabel]="'Country'"
  [showSearchbox]="true"
  [(ngModel)]="selectedCountryCodeItem"
  [ngModelOptions]="{standalone: true}"
  (onSelect)="onSelectedCountryCodeSelect($event)">
  @for (item of countryCodeDataView; track item.value) {
    <ap-dropdown-list-item #dropdownListItem [item]="item"
      [ariaLabel]="setFormDropdownAriaLabel(item, 'Country')"
      (onSelectItem)="onDropdownSelectItem($event)"></ap-dropdown-list-item>
  }
</ap-dropdown>
        </div>
}
      </div>

      <!-- Row 3: HTKO / FSE / Source Type / Project Tagging -->
      <div class="row">
        @if (newArray.indexOf('HTKO') > -1) {
<div class="col-md-2">
          <label>HTKO</label>
          <ap-dropdown class="ftc-form-dropdown field-full-width" [list]="htkoDataView"
  [selectType]="'single'" [title]="'HTKO'" [hideTitleOnInput]="true" [inputAriaLabel]="'HTKO'"
  [disabled]="selectedBasketCodeDesc !== 'Passive'"
  [(ngModel)]="selectedHtkoCodeItem"
  [ngModelOptions]="{standalone: true}"
  (onSelect)="onSelectedHtkoCodeSelect($event)">
  @for (item of htkoDataView; track item.value) {
    <ap-dropdown-list-item #dropdownListItem [item]="item"
      [ariaLabel]="setFormDropdownAriaLabel(item, 'HTKO')"
      (onSelectItem)="onDropdownSelectItem($event)"></ap-dropdown-list-item>
  }
</ap-dropdown>
        </div>
}

        @if (newArray.indexOf('FSE') > -1) {
<div class="col-md-2">
          <label>FSE</label>
          <ap-dropdown class="ftc-form-dropdown field-full-width" [list]="fsiDataView"
  [selectType]="'single'" [title]="'FSE'" [hideTitleOnInput]="true" [inputAriaLabel]="'FSE'"
  [disabled]="!(selectedBasketCodeDesc === 'Passive' && disableFSE !== 'true' && disableFSE !== undefined)"
  [(ngModel)]="selectedFsiCodeItem"
  [ngModelOptions]="{standalone: true}"
  (onSelect)="onSelectedFsiCodeSelect($event)">
  @for (item of fsiDataView; track item.value) {
    <ap-dropdown-list-item #dropdownListItem [item]="item"
      [ariaLabel]="setFormDropdownAriaLabel(item, 'FSE')"
      (onSelectItem)="onDropdownSelectItem($event)"></ap-dropdown-list-item>
  }
</ap-dropdown>
        </div>
}

        @if (newArray.indexOf('Source Type') > -1) {
<div class="col-md-2">
          <label>Source Type</label>
          <ap-dropdown class="ftc-form-dropdown field-full-width" [list]="sourceTypeCodeDataView"
  [selectType]="'single'" [title]="'Source Type'" [hideTitleOnInput]="true" [inputAriaLabel]="'Source Type'"
  [disabled]="transCatgMapDesc === 'Y' || QARScenario === 'Y'"
  [(ngModel)]="selectedSourceTypeCodeItem"
  [ngModelOptions]="{standalone: true}"
  (onSelect)="onSelectedSourceTypeCodeSelect($event)">
  @for (item of sourceTypeCodeDataView; track item.value) {
    <ap-dropdown-list-item #dropdownListItem [item]="item"
      [ariaLabel]="setFormDropdownAriaLabel(item, 'Source Type')"
      (onSelectItem)="onDropdownSelectItem($event)"></ap-dropdown-list-item>
  }
</ap-dropdown>
        </div>
}

        @if (newArray.indexOf('Project Tagging') > -1) {
<div class="col-md-2">
          <label>Project Tagging</label>
          <ap-dropdown class="ftc-form-dropdown field-full-width" [list]="projectTagCodeDataView"
  [selectType]="'single'" [title]="'Project Tagging'" [hideTitleOnInput]="true" [inputAriaLabel]="'Project Tagging'"
  [(ngModel)]="selectedProjectTaggingCodeItem"
  [ngModelOptions]="{standalone: true}"
  (onSelect)="onSelectedProjectTaggingCodeSelect($event)">
  @for (item of projectTagCodeDataView; track item.value) {
    <ap-dropdown-list-item #dropdownListItem [item]="item"
      [ariaLabel]="setFormDropdownAriaLabel(item, 'Project Tagging')"
      (onSelectItem)="onDropdownSelectItem($event)"></ap-dropdown-list-item>
  }
</ap-dropdown>
        </div>
}
      </div>

      <!-- Row 4: Notes -->
      <div class="row">
        @if (newArray.indexOf('Notes') > -1) {
<div class="col-md-4">
          <label>Notes</label>
          <textarea maxlength="500" class="form-control"
                    [(ngModel)]="selectedNotes"
                    [ngModelOptions]="{standalone: true}"></textarea>
          <div style="text-align: right; font-weight: normal;">
            <label style="font-weight: normal; font-size: x-small; color: gray;">Max length 500</label>
          </div>
        </div>
}
      </div>

      <!-- Row 5: Method / Base FDII / Base Basket / Base Type / Base Level / Base Entity Level -->
      <div class="row">
        @if (newArray.indexOf('Method') > -1) {
<div class="col-md-2">
          <label>Method</label>
          <ap-dropdown class="ftc-form-dropdown field-full-width" [list]="methodCodeDataView"
  [selectType]="'single'" [title]="'Method'" [hideTitleOnInput]="true" [inputAriaLabel]="'Method'"
  [disabled]="QARScenario === 'Y'"
  [(ngModel)]="selectedMethodCodeItem"
  [ngModelOptions]="{standalone: true}"
  (onSelect)="onEditCountCheckForActualFromDropdown($event)">
  @for (item of methodCodeDataView; track item.value) {
    <ap-dropdown-list-item #dropdownListItem [item]="item"
      [ariaLabel]="setFormDropdownAriaLabel(item, 'Method')"
      (onSelectItem)="onDropdownSelectItem($event)"></ap-dropdown-list-item>
  }
</ap-dropdown>
        </div>
}

        <!-- Multi-select Base FDII (non-single-select mode, non-INTEXP/RESEARCH) -->
        @if (selectedGieName !== 'INTEXP' && selectedGieName !== 'RESEARCH' && displaySingleSelectBase !== 'true') {

          @if (newArray.indexOf('Base FDII') > -1 && baseFDIIData.length > 0) {
<div class="col-md-2">
            <label>Base FDII</label>
            <ap-dropdown style="width:100%" [selectType]="'multiple'" [enableNgContent]="false"
                           [list]="dropdownLists['baseFDII']" [optionName]="'CODE_DESCRIPTION'" [optionValue]="'CODE_KEY'"
                           [title]="'Select'" [inputAriaLabel]="'Base FDII'" [hideTitleOnInput]="true"
                           [showSearchbox]="true" [showSelectAll]="true" [clearSearchKeyword]="true"
                           (onFilterResult)="onDropdownFilterResult('baseFDII', $event)"
                           [(ngModel)]="selectedBaseFdiiCodes" [ngModelOptions]="{standalone: true}">
            </ap-dropdown>
          </div>
}

          @if (newArray.indexOf('Base Basket') > -1 && baseBasketData.length > 0) {
<div class="col-md-2">
            <label>Base Basket</label>
            <ap-dropdown style="width:100%" [selectType]="'multiple'" [enableNgContent]="false"
                           [list]="dropdownLists['baseBasket']" [optionName]="'CODE_DESCRIPTION'" [optionValue]="'CODE_KEY'"
                           [title]="'Select'" [inputAriaLabel]="'Base Basket'" [hideTitleOnInput]="true"
                           [showSearchbox]="true" [showSelectAll]="true" [clearSearchKeyword]="true"
                           (onFilterResult)="onDropdownFilterResult('baseBasket', $event)"
                           [(ngModel)]="selectedBaseBasketCode" [ngModelOptions]="{standalone: true}">
            </ap-dropdown>
          </div>
}
        
}

        <!-- Single-select Base FDII / Base Basket (Allocate mode) -->
        @if (displaySingleSelectBase === 'true') {

          @if (newArray.indexOf('Base FDII') > -1 && baseFDIIData.length > 0) {
<div class="col-md-2">
            <label>Base FDII</label>
            <ap-dropdown class="ftc-form-dropdown field-full-width" [list]="baseFDIIDataView"
  [selectType]="'single'" [title]="'Base FDII'" [hideTitleOnInput]="true" [inputAriaLabel]="'Base FDII'"
  [(ngModel)]="selectedBaseFdiiCodesItem"
  [ngModelOptions]="{standalone: true}"
  (onSelect)="onSelectedBaseFdiiCodesSelect($event)">
  @for (item of baseFDIIDataView; track item.value) {
    <ap-dropdown-list-item #dropdownListItem [item]="item"
      [ariaLabel]="setFormDropdownAriaLabel(item, 'Base FDII')"
      (onSelectItem)="onDropdownSelectItem($event)"></ap-dropdown-list-item>
  }
</ap-dropdown>
          </div>
}

          @if (newArray.indexOf('Base Basket') > -1 && baseBasketData.length > 0) {
<div class="col-md-2">
            <label>Base Basket</label>
            <ap-dropdown class="ftc-form-dropdown field-full-width" [list]="basketCodeAllocateDataView"
  [selectType]="'single'" [title]="'Base Basket'" [hideTitleOnInput]="true" [inputAriaLabel]="'Base Basket'"
  [(ngModel)]="selectedBaseBasketCodeItem"
  [ngModelOptions]="{standalone: true}"
  (onSelect)="onSelectedBaseBasketCodeSelect($event)">
  @for (item of basketCodeAllocateDataView; track item.value) {
    <ap-dropdown-list-item #dropdownListItem [item]="item"
      [ariaLabel]="setFormDropdownAriaLabel(item, 'Base Basket')"
      (onSelectItem)="onDropdownSelectItem($event)"></ap-dropdown-list-item>
  }
</ap-dropdown>
          </div>
}
        
}

        <!-- Base Type (multi-select) -->
        @if (newArray.indexOf('Base Type') > -1 && baseTypeData.length > 0 && gIncomeMethodFlag !== 'true') {
<div class="col-md-2">
          <label>Base Type</label>
          <ap-dropdown style="width:100%" [selectType]="'multiple'" [enableNgContent]="false"
                         [list]="dropdownLists['baseType']" [optionName]="'CODE_DESCRIPTION'" [optionValue]="'CODE_KEY'"
                         [title]="'Select'" [inputAriaLabel]="'Base Type'" [hideTitleOnInput]="true"
                         [showSearchbox]="true" [showSelectAll]="true" [clearSearchKeyword]="true"
                         (onFilterResult)="onDropdownFilterResult('baseType', $event)"
                         [(ngModel)]="selectedBaseTypeCode" [ngModelOptions]="{standalone: true}"
                         [disabled]="selectedBaseLevelCodeDESC === 'ALL ME'">
          </ap-dropdown>
        </div>
}

        @if (newArray.indexOf('Base Type') > -1 && baseTypeData.length > 0 && gIncomeMethodFlag === 'true') {
<div class="col-md-2">
          <label>Base Type</label>
          <ap-dropdown style="width:100%" [selectType]="'multiple'" [enableNgContent]="false"
                         [list]="dropdownLists['baseType']" [optionName]="'CODE_UPDATED_DESCRIPTION'" [optionValue]="'CODE_KEY'"
                         [title]="'Select'" [inputAriaLabel]="'Base Type'" [hideTitleOnInput]="true"
                         [showSearchbox]="true" [showSelectAll]="true" [clearSearchKeyword]="true"
                         (onFilterResult)="onDropdownFilterResult('baseType', $event)"
                         [(ngModel)]="selectedBaseTypeCode" [ngModelOptions]="{standalone: true}"
                         [disabled]="selectedBaseLevelCodeDESC === 'ALL ME'">
          </ap-dropdown>
        </div>
}

        <!-- Base Level -->
        @if (newArray.indexOf('Base Level') > -1) {
<div class="col-md-2">
          <label>Base Level</label>
          <ap-dropdown class="ftc-form-dropdown field-full-width" [list]="baseLevelDataView"
  [selectType]="'single'" [title]="'Base Level'" [hideTitleOnInput]="true" [inputAriaLabel]="'Base Level'"
  [disabled]="disableBaseLevels === 'Yes'"
  [(ngModel)]="selectedBaseLevelCodeItem"
  [ngModelOptions]="{standalone: true}"
  (onSelect)="onSelectedBaseLevelCodeSelect($event)">
  @for (item of baseLevelDataView; track item.value) {
    <ap-dropdown-list-item #dropdownListItem [item]="item"
      [ariaLabel]="setFormDropdownAriaLabel(item, 'Base Level')"
      (onSelectItem)="onDropdownSelectItem($event)"></ap-dropdown-list-item>
  }
</ap-dropdown>
        </div>
}

        <!-- Base Entity Level -->
        @if (newArray.indexOf('Base Entity Level') > -1) {
<div class="col-md-2">
          <label>Base Entity Level</label>
          <ap-dropdown class="ftc-form-dropdown field-full-width" [list]="baseEntityDataView"
  [selectType]="'single'" [title]="'Base Entity Level'" [hideTitleOnInput]="true" [inputAriaLabel]="'Base Entity Level'"
  [disabled]="disableBaseLevels === 'Yes'"
  [(ngModel)]="selectedBaseEntityLevelCodeItem"
  [ngModelOptions]="{standalone: true}"
  (onSelect)="onSelectedBaseEntityLevelCodeSelect($event)">
  @for (item of baseEntityDataView; track item.value) {
    <ap-dropdown-list-item #dropdownListItem [item]="item"
      [ariaLabel]="setFormDropdownAriaLabel(item, 'Base Entity Level')"
      (onSelectItem)="onDropdownSelectItem($event)"></ap-dropdown-list-item>
  }
</ap-dropdown>
        </div>
}
      </div>

      <!-- Attribute Table -->
      @if (selectedAttributeRow.length > 0) {
<div class="divShadow">
        <table class="table table-hover table-bordered table-striped table-condensed">
          <thead>
            <tr>
              <th>LEID</th>
              <th>Tax Code</th>
              <th>Reporting Period</th>
              <th>ME Code</th>
              <th>Gross Inc/Exp</th>
              <th>Trans Category</th>
              @if (newArray.indexOf('Basket') > -1) {
<th>Basket</th>
}
              @if (newArray.indexOf('SIC Code') > -1) {
<th>SIC Code</th>
}
              @if (newArray.indexOf('FDII') > -1) {
<th>FDII</th>
}
              @if (newArray.indexOf('Applicable Year') > -1) {
<th>WH Applicable Year</th>
}
              @if (newArray.indexOf('Line No') > -1) {
<th>Line No</th>
}
              @if (newArray.indexOf('Beat') > -1) {
<th>BEAT</th>
}
              @if (newArray.indexOf('Beat Type') > -1) {
<th>BEAT Type</th>
}
              @if (newArray.indexOf('Beat Withhold') > -1) {
<th>Subject to BEAT Withhold (%)</th>
}
              @if (newArray.indexOf('Related/Unrelated') > -1) {
<th>Related / Unrelated</th>
}
              @if (newArray.indexOf('Trading Partner') > -1) {
<th>Trading Partner</th>
}
              @if (newArray.indexOf('Country') > -1) {
<th>Country</th>
}
              @if (newArray.indexOf('HTKO') > -1) {
<th>HTKO</th>
}
              @if (newArray.indexOf('FSE') > -1) {
<th>FSE</th>
}
              @if (newArray.indexOf('Source Type') > -1) {
<th>Source Type</th>
}
              @if (newArray.indexOf('Project Tagging') > -1) {
<th>Project Tagging</th>
}
              @if (newArray.indexOf('Notes') > -1) {
<th>Notes</th>
}
              @if (newArray.indexOf('Method') > -1) {
<th>Method</th>
}
              @if (newArray.indexOf('Base FDII') > -1) {
<th>Base FDII</th>
}
              @if (newArray.indexOf('Base Basket') > -1) {
<th>Base Basket</th>
}
              @if (newArray.indexOf('Base Type') > -1) {
<th>Base Type</th>
}
              @if (newArray.indexOf('Base Level') > -1) {
<th>Base Level</th>
}
              @if (newArray.indexOf('Base Entity Level') > -1) {
<th>Base Entity Level</th>
}
            </tr>
          </thead>
          <tbody>
            @for (t of selectedAttributeRow; track $index) {
<tr>
              <td>{{ t.LEID }}</td>
              <td>{{ t.CDR_NO }}</td>
              <td>{{ t.REPORTING_PERIOD }}</td>
              <td>{{ t.ME_CODE }}</td>
              <td>{{ t.GIE_SHORT_DESC }}</td>
              <td>{{ t.TRANS_CATG_NAME }}</td>
              @if (newArray.indexOf('Basket') > -1) {
<td>{{ t.BASKET_0 }}</td>
}
              @if (newArray.indexOf('SIC Code') > -1) {
<td>{{ t.SIC_CODES_0 }}</td>
}
              @if (newArray.indexOf('FDII') > -1) {
<td>{{ t.FDII_0 }}</td>
}
              @if (newArray.indexOf('Applicable Year') > -1) {
<td>{{ t.APPLICABLE_YEAR_0 }}</td>
}
              @if (newArray.indexOf('Line No') > -1) {
<td>{{ t.LINE_NO_0 }}</td>
}
              @if (newArray.indexOf('Beat') > -1) {
<td>{{ t.BEAT_0 }}</td>
}
              @if (newArray.indexOf('Beat Type') > -1) {
<td>{{ t.BEAT_TYPE_0 }}</td>
}
              @if (newArray.indexOf('Beat Withhold') > -1) {
<td>{{ t.BEAT_WITHHOLD_0 }}</td>
}
              @if (newArray.indexOf('Related/Unrelated') > -1) {
<td>{{ t.RELATED_UNRELATED_0 }}</td>
}
              @if (newArray.indexOf('Trading Partner') > -1) {
<td>{{ t.ACTUAL_TP_KEY_LENAME_0 }}</td>
}
              @if (newArray.indexOf('Country') > -1) {
<td>{{ t.COUNTRY_0 }}</td>
}
              @if (newArray.indexOf('HTKO') > -1) {
<td>{{ t.HTKO_0 }}</td>
}
              @if (newArray.indexOf('FSE') > -1) {
<td>{{ t.FSE_0 }}</td>
}
              @if (newArray.indexOf('Source Type') > -1) {
<td>{{ t.SOURCE_TYPE_0 }}</td>
}
              @if (newArray.indexOf('Project Tagging') > -1) {
<td>{{ t.PROJECT_TAGGING_0 }}</td>
}
              @if (newArray.indexOf('Notes') > -1) {
<td>{{ t.NOTES_0 }}</td>
}
              @if (newArray.indexOf('Method') > -1) {
<td>{{ t.METHOD_0 }}</td>
}
              @if (newArray.indexOf('Base FDII') > -1) {
<td>{{ t.BASE_FDII_0 }}</td>
}
              @if (newArray.indexOf('Base Basket') > -1) {
<td>{{ t.BASE_BASKET_0 }}</td>
}
              @if (newArray.indexOf('Base Type') > -1) {
<td>{{ t.BASE_TYPE_0 }}</td>
}
              @if (newArray.indexOf('Base Level') > -1) {
<td>{{ t.BASE_LEVEL_0 }}</td>
}
              @if (newArray.indexOf('Base Entity Level') > -1) {
<td>{{ t.BASE_ENTITY_LEVEL_0 }}</td>
}
            </tr>
}
          </tbody>
        </table>
      </div>
}

    </div>
}
  </div>
</div>
</form>

<!-- Footer -->
<div class="modal-footer" [hidden]="minimise">
  <button class="btn btn-info btn-sm" type="button"
          (click)="save()"
          [disabled]="isSaveClicked || isError">
    @if (crudLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
} Save
  </button>
  <button class="btn btn-danger-outline btn-sm" type="button" (click)="reset()">Reset</button>
  <button class="btn btn-warning btn-sm" type="button" (click)="cancel()">Cancel</button>
</div>
